import { BASE_METHODS, CustomErrorType } from "../../constants/action-types";
import {
  setPushMessage,
  setPushMessageActionStart,
  setPushMessageErrorMessage,
} from "../../constants/reducers/push-message.reducer";
import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";
import { AxiosResponse } from "axios";
import { GetOnePushMessageDTO } from "../../constants/dto/push-message";

type GetPushMessageProp = {
  id: number;
};

let body: GetOnePushMessageDTO;

export const getOnePushMessage = async ({ id }: GetPushMessageProp) => {
  store.dispatch(setPushMessageActionStart(true));

  const queryParams = new URLSearchParams();

  if (id) queryParams.append("id", id.toString());

  const request = await createCall(
    "cms/push-messages/get-one",
    BASE_METHODS.GET,
    "application/json",
    "1.0.0",
    undefined,
    queryParams
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(GetOnePushMessageDTO, response.data);
    const errors = await validate(body);
    if (errors.length > 0) {
      store.dispatch(
        setPushMessageErrorMessage(TextEnum.GET_ONE_PUSH_MESSAGE_INVALID_RESPONSE)
      );
      return null;
    }
    store.dispatch(setPushMessage({ pushMessage: response.data.pushMessage }));
    return response;
  } catch (error) {
    const responseError = request as any;
    const errorResponseData: CustomErrorType = responseError.response?.data;
    if (errorResponseData) {
      let errorMessage = "";
      switch (errorResponseData.code) {
        case 2001:
          errorMessage = TextEnum.GET_ONE_PUSH_MESSAGE_NOT_FOUND;
          break;
        default:
          break;
      }
      store.dispatch(setPushMessageErrorMessage(errorMessage));
      return null;
    }
    store.dispatch(setPushMessageActionStart(false));
    store.dispatch(timeoutError());
    return null;
  }
};
